export const cilArrowBottom = ["24 24","<path d='M17.25 15.879l-4.5 4.5v-19.558h-1.5v19.558l-4.5-4.5-1.061 1.061 6.311 6.31 6.31-6.31-1.061-1.061z'></path>"]